import { render, staticRenderFns } from "./SelfCertnComm.vue?vue&type=template&id=cb362a3a&scoped=true"
import script from "./SelfCertnComm.vue?vue&type=script&lang=js"
export * from "./SelfCertnComm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb362a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb362a3a')) {
      api.createRecord('cb362a3a', component.options)
    } else {
      api.reload('cb362a3a', component.options)
    }
    module.hot.accept("./SelfCertnComm.vue?vue&type=template&id=cb362a3a&scoped=true", function () {
      api.rerender('cb362a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/SelfCertnComm.vue"
export default component.exports